import {Pipe, PipeTransform} from '@angular/core';
import {Text, TextFormatter} from '@atlas/businesstypes';

/**
 * @ngModule BusinessTypesModule
 */
@Pipe({name: 'atlasText'})
export class TextPipe implements PipeTransform {
  public transform(value: any): string {
    return Text.isText(value) ? TextFormatter.format(value) : value;
  }
}
